<template>
  <v-dialog v-model="dialog" persistent="persistent" max-width="600px">
    <v-card grid-list-md="grid-list-md">
      <v-toolbar dark="dark" color="primary">
        <v-toolbar-title>{{ $t("labels.newProduct") }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon="icon" dark="dark" @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-container class="pa-0" grid-list-lg="grid-list-lg">
          <v-layout row="row" wrap="wrap">
            <v-flex xs12="xs12">
              <v-text-field
                :error-messages="nameErrors"
                v-model="Product.productDetail"
                label="Name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12="xs12" md6="md6">
              <v-select
                :error-messages="productTypeErrors"
                v-model="Product.productType"
                :items="productType"
                label="Product Type"
              ></v-select>
            </v-flex>
            <v-flex xs12="xs12" md3="md3">
              <v-text-field
                v-model="Product.amount"
                class="right-input"
                label="Price"
              ></v-text-field>
            </v-flex>
            <v-flex xs12="xs12" md3="md3">
              <v-text-field
                v-model="Product.stock"
                class="right-input"
                label="Current Stock"
              ></v-text-field>
            </v-flex>
            <v-flex xs12="xs12">
              <v-text-field v-model="Product.imageUrl" label="Image Url"></v-text-field>
            </v-flex>
            <v-flex xs12="xs12" md3="md3">
              <v-checkbox
                label="Apply Tax"
                hide-details="hide-details"
                color="primary"
                v-model="Product.applyTax"
              >
              </v-checkbox>
            </v-flex>
            <v-flex xs12="xs12" md3="md3">
              <v-checkbox
                label="Track Inventory"
                hide-details="hide-details"
                color="primary"
                v-model="Product.trackInventory"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12="xs12" md3="md3">
              <v-checkbox
                label="Track Serial Number"
                hide-details="hide-details"
                color="primary"
                v-model="Product.trackSerialNumber"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12="xs12" md3="md3">
              <v-checkbox
                label="Product Active"
                hide-details="hide-details"
                color="primary"
                v-model="Product.isActive"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12="xs12">
              <v-textarea
                counter="counter"
                auto-grow="auto-grow"
                v-model="Product.description"
                :label="$t('labels.description')"
              ></v-textarea>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat="flat" @click="close()">Close</v-btn>
        <v-btn color="blue darken-1" :loading="loading" dark="dark" @click="save()">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import productService from "../service.js";

const { validationMixin } = require("vuelidate");
const { required, minLength } = require("vuelidate/lib/validators");

export default {
  props: {
    createDialog: {
      default: false
    },
    createFromStore: {
      type: Boolean
    }
  },
  name: "create-product",
  data() {
    return {
      loading: false,
      dialog: false,
      productType: [
        "Monthly",
        "Promotion",
        "Unlock",
        "Hardware",
        "Renew",
        "Card",
        "Prepaid Balance",
        "Service",
        "Paper",
      ],
      Product: {
        productDetail: null,
        productType: null,
        description: null,
        amount: 0,
        imageUrl: null,
        applyTax: false,
        trackSerialNumber: false,
        stock: 0,
        trackInventory: false,
        isActive: true
      }
    };
  },
  mixins: [validationMixin],
  validations: {
    Product: {
      productDetail: {
        required,
        minLength: minLength(5)
      },
      productType: {
        required
      }
    }
  },
  computed: {
    ...mapGetters("global", ["comboBox", "comboBoxByID", "currentUser"]),
    nameErrors() {
      const errors = [];
      if (!this.$v.Product.productDetail.$dirty) return errors;
      if (!this.$v.Product.productDetail.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.Product.productDetail.minLength)
        errors.push("Field must be at least 5 characters long");
      return errors;
    },
    productTypeErrors() {
      const errors = [];
      if (!this.$v.Product.productType.$dirty) return errors;
      if (!this.$v.Product.productType.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      return errors;
    }
  },
  watch: {
    Product: {
      handler(val) {
        if (val.productType === "Hardware") {
          this.trackInventory = true;
        } else {
          this.trackInventory = false;
          this.serialTrack = false;
          this.Product.trackInventory = false;
          this.Product.trackSerialNumber = false;
        }
        if (val.trackInventory) {
          this.serialTrack = true;
        } else {
          this.serialTrack = false;
        }
      },
      deep: true
    },
    createDialog(val) {
      this.dialog = val;
    }
  },
  methods: {
    close() {
      this.empty();
      this.$emit("close");
    },
    empty() {
      this.Product = {
        productDetail: null,
        productType: null,
        description: null,
        amount: 0,
        imageUrl: null,
        applyTax: false,
        trackSerialNumber: false,
        stock: 0,
        trackInventory: false,
        isActive: true
      };
      this.$v.$reset();
    },
    save() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000
          })
          .fire({
            type: "error",
            title: this.$t("toastMessage.text.invalidFields")
          });
      } else {
        this.loading = true;
        return productService
          .create(this.Product)
          .then(result => {
            if (result.status) {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000
                })
                .fire({
                  type: "success",
                  title: "Product is created"
                });
              this.empty();
              this.loading = false;
              this.$emit("submit");
            }
          })
          .catch(err => {
            this.loading = false;
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000
              })
              .fire({
                type: "error",
                title: err.data.data
              });
          });
      }
    }
  }
};
</script>

<style scoped></style>
